import React from 'react';
import { FormattedMessage } from 'react-intl';

import { getGiftOfferSummary, DefaultIntlFormatValues, getGiftOfferTypeAsMessage } from '@ratehub/base-ui';

import COMMON_MESSAGES from '../definitions/Messages';
import isCardEligibleForReferralOffer from './isCardEligibleForReferralOffer';


/**
 * Return an object with a string or React message array and a banner type suitable to be used for a simple banner
 * above a credit card, based on a gift offer or eligible referral offer associated with the card.
 * If neither of those conditions apply, returns `null`.
 * @param {object} args - The arguments object
 * @param {object} args.giftCardOffer - the card’s gift offer, if any
 * @param {boolean} args.hasReferralOffer - is this card eligible for a referral offer?
 * @param {number} args.referralOfferValue - the value of the referral offer, if any
 * @param {boolean} [args.isMobile=false] - Boolean indicating if the context is mobile
 * @param {import('react-intl').IntlShape} intl - the internationalization object
 * @returns {React.JSX.Element|string|null} - message or null
 */
function getCardBannerMessage({ giftCardOffer, hasReferralOffer, referralOfferValue, isMobile = false }, intl) {
    if (giftCardOffer && isCardEligibleForReferralOffer(hasReferralOffer)) {
        return (
            <FormattedMessage
                id="edb.cc.gift-offer-and-referral-offer"
                defaultMessage="Earn <strong>{referralOfferValue, number, CAD0}</strong> for referral + <strong>{giftOfferValue, number, CAD0}</strong> {giftOfferType}"
                values={{
                    ...DefaultIntlFormatValues,
                    giftOfferValue: giftCardOffer.maxDollarValue,
                    giftOfferType: getGiftOfferTypeAsMessage(giftCardOffer.offerType, intl),
                    referralOfferValue,
                }}
            />
        );
    }

    if (giftCardOffer) {
        return getGiftOfferSummary({ giftCardOffer, intl, isMobile });
    }

    if (isCardEligibleForReferralOffer(hasReferralOffer)) {
        return (
            <FormattedMessage
                {...COMMON_MESSAGES.eligibleForReferralBonus}
                values={{
                    ...DefaultIntlFormatValues,
                    referralOfferValue,
                }}
            />
        );
    }

    return null;
}


export default getCardBannerMessage;
